import angular from 'angular';
import $ from 'jquery';
import './style.scss';
import Logger from '../../../shared/logger';

const DEFAULT_TIMEOUT = 25000;
const DEFAULT_RETRIES = 5;

// eslint-disable-next-line no-useless-escape
const urlRegularExpression = /https?:\/\/(www\.|\w+\.)?linkedin\.com\/in\/.{3,}/;
const urlRegexp = new RegExp(urlRegularExpression);

export class ImportLinkedinCandidateDialogController {
    importInProcess = false;

    talentId = null;

    linkedinURL = '';

    isLinkedinURLValid = true;

    /* @ngInject */
    constructor(
        $scope,
        $stateParams,
        NotificationService,
        TalentService,
        $filter,
        $state,
        $timeout,
        $localStorage,
        CandidateService,
    ) {
        this.notificationService = NotificationService;
        this.talentService = TalentService;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$state = $state;
        this.$scope = $scope;
        this.$localStorage = $localStorage;
        this.CandidateService = CandidateService;
    }

    onLinkedinUrlChange() {
        this.isLinkedinURLValid = urlRegexp.test(this.linkedinURL);
    }

    handleError(error) {
        Logger.error(error);
        this.importInProcess = false;
        this.notificationService.error('IMPORT_CANDIDATE_ERROR');
    }

    async progressingRetryImportStatusGet({ request, retries, timeout, step, currentTimeout }) {
        if (!retries) {
            this.handleError('Reached maximum number of retries');
        }

        try {
            const { result: { status, talentId, error } } = await request();

            switch (status) {
                case 'pending': {
                    let timeoutId;
                    return new Promise((resolve) => {
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(resolve, currentTimeout);
                    })
                        .then(() =>
                            this.progressingRetryImportStatusGet({
                                request,
                                retries: retries - 1,
                                timeout,
                                step,
                                currentTimeout: Math.min(timeout, currentTimeout + step),
                            }),
                        );
                }
                case 'done':
                    return talentId;
                case 'error':
                    this.handleError(error);
                    break;
                default:
                    this.handleError('Unexpected status');
                    break;
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    async submitImportCandidate(form) {
        form.$setSubmitted(true);
        this.importInProcess = true;

        if (!(this.linkedinURL || '').match(urlRegexp) || this.isBadUrl) {
            this.notificationService.error(this.$filter('translate')('URL_FORMAT_ERROR'));
            this.importInProcess = false;

            return;
        }

        try {
            const { result: { cacheKey } } = await this.talentService.importOnlyFromLinkedInUrl({ resumeUrl: this.linkedinURL });
            const requestImportStatus = () => this.talentService.getImportFromLinkedInUrlStatus({ cacheKey });
            const retryTimeoutStep = 1000;
            const retries = this.$localStorage.sysDefaults.importLinkedInProfileRetryAmount || DEFAULT_RETRIES;
            const timeout = this.$localStorage.sysDefaults.importLinkedInProfileRetryTimeout || DEFAULT_TIMEOUT;
            const talentId = await this.progressingRetryImportStatusGet({
                request: requestImportStatus,
                retries,
                timeout,
                step: retryTimeoutStep,
                currentTimeout: retryTimeoutStep,
            });

            if (!talentId) {
                return this.showErrorMessage('IMPORT_CANDIDATE_ERROR');
            }

            const importResponse = await this.talentService.claimCandidateImportedByLinkedInUrl({
                talentId,
                positionId: this.positionId,
                recruiterId: this.recruiterId,
            });

            if (!importResponse || !importResponse.result) {
                return this.showErrorMessage('IMPORT_CANDIDATE_ERROR');
            }

            if (importResponse.result.importStatusCode === -1) {
                return this.showErrorMessage(importResponse.result.importStatusMessage);
            }

            if (typeof this.onClaimSuccess === 'function') {
                this.onClaimSuccess();
            }

            const { workflow, candidate, importStatusMessage, enableProfileRedirect } = importResponse.result;

            this.dialogMessage = importStatusMessage;
            this.talentId = candidate.talentId;
            this.resultWorflow = workflow;
            this.linkedinURL = '';
            this.enableProfileRedirect = enableProfileRedirect;
            this.importInProcess = false;
            this.importCandidateStatusDialogShow();
            this.importCandidateDialogClose();
            this.$scope.$apply();
        } catch (error) {
            this.handleError(error);
        }
    }

    showErrorMessage(errorMessage) {
        this.notificationService.error(errorMessage || 'IMPORT_CANDIDATE_ERROR');
        this.importInProcess = false;
        this.$scope.$apply();
    }

    goToProfilePage() {
        this.importCandidateStatusDialogClose();

        $('#importCandidateStatusModalDialog')
            .on('hidden.bs.modal', () => {
                this.$state.go('recruiter.candidatesJob', {
                    positionId: this.resultWorflow.positionId,
                    recruiterId: this.resultWorflow.recruiterId,
                    talentID: this.talentId,
                    currCandidatePage: 1,
                    workflowStep: this.resultWorflow.recruiterStatus.current,
                }, { reload: true });
            });
    }

    importCandidateDialogShow() {
        this.importCandidateStatusDialogClose();
        $('#importCandidateModalDialog').modal('show');
    }

    importCandidateDialogClose() {
        this.linkedinURL = '';
        $('#importCandidateModalDialog').modal('hide');
    }

    importCandidateStatusDialogShow() {
        $('#importCandidateStatusModalDialog').modal('show');
    }

    importCandidateStatusDialogClose() {
        this.linkedinURL = '';
        $('#importCandidateStatusModalDialog').modal('hide');
    }
}

angular
    .module('TALENYA-FE')
    .controller('importLinkedinCandidateCtrl', ImportLinkedinCandidateDialogController);
